<template>
    <b-datepicker
        :placeholder="placeholder"
        v-bind="initDatepicker"
        :date-formatter="formatInputToDay"
        :first-day-of-week="1"
        v-model="innerValue"
        :date-creator="customDate"
        :day-names="[]"
        :selectable-dates="selectableDates"
    >
        <template #header>
            <b-field>
            </b-field>
        </template>
    </b-datepicker>
</template>

<script>
import moment from "moment";
// This hardcoded date is set because this specific date
// has 31 days and the first date starts on mondays so the
// datepicker dropdown dosent have any blanks spaces at the begining
const fixedDate = new Date('2018-01-01T03:24:00')

export default {
    name: "DayPicker",
    data() {
        return{
            initDatepicker: {
                locale: "es",
                "trap-focus": true,
                icon: "calendar-day",
                class: "icon-is-right",
                "nearby-month-days": false,
            },
            innerValue: null,
            selectableDates: this.selectableDays.reduce(
                (acc,val)=>[...acc, moment(fixedDate).clone().add(val-1,'d').toDate()],
                []
            )
        }
    },
    methods: {
        formatInputToDay(date) {
            return `${moment(date).date()} del mes`
        },
        customDate(){
            return fixedDate
        }
    },
    props: {
        placeholder:{
            type: String,
            default: "Selecciona un día"
        },
        selectableDays: {
            type: Array,
            default: ()=>[]
        }
    },
    watch: {
        innerValue(newVal) {
            this.$emit("input", moment(newVal).date());
        },
        value(newVal) {
            this.innerValue = newVal;
        },
    }
};
</script>